module.exports = __webpack_public_path__ + "img/Component 53 – 1.c25f639f.svg";